/**
 * Entry application component used to compose providers and render Routes.
 */
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Routes } from '../app/router/Routes';
import { I18nProvider } from '../_metronic/i18n';
import { LayoutSplashScreen, MaterialThemeProvider } from '../_metronic/layout';
import { ErrorBoundary } from './ErrorHandler';
import useTheme from './hooks/useTheme';
import { Helmet } from 'react-helmet';
import { alert } from './helpers/rsuite/Alerts';
import AwsCWRum from '../config/rum';

AwsCWRum();

export default function App ({ store, persistor }) {
    const theme = useTheme();

    useEffect(() => {
        const handleOnline = () => {
            alert('success', 'Ya tenes conexión. ', 7000, 'topCenter', null, null, 'error-boundary');
        };
        const handleOffline = () => {
            alert('error', 'Verifique su conexión a internet y vuelva a intentar. ', 7000, 'topCenter', null, null, 'error-boundary');
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <>
            <Helmet>
                <title>{theme.title}</title>
                <link
                    rel="icon"
                    type="image/x-icon"
                    href={`/${theme.name}/favicon.ico`}
                />

            </Helmet>
            <Provider store={store}>
                {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
                <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
                    {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
                    <React.Suspense fallback={<LayoutSplashScreen />}>
                        {/* Override `basename` (e.g: `homepage` in `package.json`) */}
                        <BrowserRouter>
                            {/* This library only returns the location that has been active before the recent location change in the current window lifetime. */}
                            <MaterialThemeProvider>
                                {/* Provide `react-intl` context synchronized with Redux state.  */}
                                <I18nProvider>
                                    <ErrorBoundary>
                                        {/* Render routes with provided `Layout`. */}
                                        <Routes />
                                    </ErrorBoundary>
                                </I18nProvider>
                            </MaterialThemeProvider>
                        </BrowserRouter>
                    </React.Suspense>
                </PersistGate>
            </Provider>
        </>

    );
}
